import { SMARTY_FOOTNOTES } from "rivals/components/shared/Form/BillingInformation/AddressVerificationModal/constants";
import RadioButton from "rivals/components/shared/Form/RadioButton";
import styles from "./Suggestion.module.scss";
import type { Props } from "./types";

/**
 * This function converts smartystreets footnotes symbols to human readable text to let the user
 * know what changed on the address they submitted initially during the registration
 * @param analysisFootnotes Indicates which changes were made to the input address. Footnotes are delimited by a # character,
 * reference on documentation page: https://www.smarty.com/docs/cloud/us-street-api#footnotes
 * @returns human readable foonotes
 */
const formatFootnotes = (analysisFootnotes?: string): string | undefined => {
  return analysisFootnotes
    ?.split("#")
    ?.map(foonote => SMARTY_FOOTNOTES[`${foonote}#`])
    ?.filter(Boolean)
    ?.join(", ");
};

const Suggestion = ({
  address,
  analysisFootnotes,
  disabled,
  isChecked,
  title
}: Props): JSX.Element => {
  const footnotes = formatFootnotes(analysisFootnotes);

  const label = (
    <div className={styles.suggestionLabel}>
      <span>{address?.street1}</span>
      <br />
      <span>
        {address?.city} {address?.state} {address?.zip}
      </span>
      {!!footnotes && (
        <>
          <br />
          <span className={styles.analysisText}>{footnotes}</span>
        </>
      )}
    </div>
  );

  return (
    <div className={styles.suggestion}>
      <h5>{title}</h5>
      <RadioButton
        disabled={!!disabled}
        isChecked={!!isChecked}
        label={label}
        onChange={(): void => {}}
      />
    </div>
  );
};

export default Suggestion;
